import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  root: {
    '&:hover': {
      cursor: 'pointer'
    },
    margin: '10px 0'
  },
  icon: {
    transform: 'scale(1.5)',
    color: '#fff'
  }
})
